import { SITE_URL } from "../helpers/Setting";
export const Fetch = async ({ body, auth, type, api }) => {
  if (body !== "logOut") {
    return await fetch(SITE_URL + api, {
      method: type,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + auth
      },
      body: body
    }).then(async res => {
      if (res.status >= 200 && res.status < 300) {
        return await res.json();
      } else if (res.status === 400
          // ||
          // res.status === 401
      ) {
        throw await res.json();
      }
      // else if (res.status === 401) {
      //   throw await res.json();
      // }
      else {
        throw res.status;
      }
    });
    // .then(error => {
    //   console.log("errorerror", error);
    //   if (error.message) {
    //     throw error.message;
    //   } else {
    //     return error;
    //   }
    // });
  } else {
    return await fetch(SITE_URL + api, {
      method: type,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + auth
      }
    }).then(res => {
      if (res.status >= 200 && res.status < 300) {
        return res;
      } else {
        return "Error " + res.status;
      }
    });
  }
};
